import React from 'react';
import ArrCheckbox from '../arr-checkbox/ArrCheckbox';
import './ArrTileSelection.scss';

export interface ArrTileSelectionProps {
  label: string;
  total: number;
  selected: boolean;
  onToggle: (selected: boolean) => void;
  disabled?: boolean;
  ariaLabel?: string;
  dataTestId: string;
}

const ArrTileSelection: React.FC<ArrTileSelectionProps> = ({
  label,
  total,
  selected,
  onToggle,
  disabled = false,
  ariaLabel,
  dataTestId,
}) => {
  const formattedTotal = new Intl.NumberFormat(undefined, {
    maximumFractionDigits: 0,
  }).format(total);

  const handleClick = () => {
    if (!disabled) {
      onToggle(!selected);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onToggle(!selected);
    }
  };

  return (
    <div
      className={`arr-tile-selection ${selected ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="checkbox"
      tabIndex={0}
      aria-label={ariaLabel}
      aria-checked={selected}
      aria-disabled={disabled}
      data-testid={`tile-selection-container-${dataTestId}`}
    >
      <ArrCheckbox
        checked={selected}
        disabled={disabled}
        data-testid="tile-selection-checkbox"
        aria-label={`${dataTestId}-checkbox`}
      />
      <span
        className="tile-label"
        data-testid={`tile-selection-label-${dataTestId}`}
      >
        {label}
      </span>
      <span
        className="tile-total"
        data-testid={`tile-selection-total-${dataTestId}`}
      >
        {formattedTotal}
      </span>
    </div>
  );
};

export const getSelectedTotal = (
  tiles: {total: number; selected: boolean}[]
): number =>
  tiles.filter((tile) => tile.selected).reduce((sum, t) => sum + t.total, 0);

export default ArrTileSelection;
